// Central content + curated imagery for Bright Oak Renovations

export const CONTACT = {
  email: "info@brightoakreno.com",
  phone: "(416) 720-9886",
  location: "Cambridge, ON",
  address: "12 Water Street North, Cambridge, ON N1R 3B2",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1682888813913-e13f18692019?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBraXRjaGVuJTIwaW50ZXJpb3IlMjByZW5vdmF0aW9ufGVufDB8fHx8MTc4MzM2MTk5OXww&ixlib=rb-4.1.0&q=85",
  kitchen: "https://images.unsplash.com/photo-1714860534425-7ce04e013dec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBraXRjaGVuJTIwaW50ZXJpb3IlMjByZW5vdmF0aW9ufGVufDB8fHx8MTc4MzM2MTk5OXww&ixlib=rb-4.1.0&q=85",
  bathroom: "https://images.unsplash.com/photo-1742134131017-44d377a611b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBtb2Rlcm4lMjBiYXRocm9vbSUyMGludGVyaW9yfGVufDB8fHx8MTc4MzM2MTk5OXww&ixlib=rb-4.1.0&q=85",
  exterior: "https://images.unsplash.com/photo-1779636834669-605c4315a648?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBob21lJTIwZXh0ZXJpb3IlMjBkZWNrfGVufDB8fHx8MTc4MzM2MTk5OXww&ixlib=rb-4.1.0&q=85",
  team: "https://images.unsplash.com/photo-1659930087003-2d64e33181f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwzfHxjYXJwZW50ZXIlMjBjb250cmFjdG9yJTIwd29vZHdvcmtpbmd8ZW58MHx8fHwxNzgzMzYxOTk5fDA&ixlib=rb-4.1.0&q=85",
  basement: "https://images.unsplash.com/photo-1765959617888-30837a158667?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHxmaW5pc2hlZCUyMGJhc2VtZW50JTIwbGl2aW5nJTIwcm9vbXxlbnwwfHx8fDE3ODMzNjIwNzZ8MA&ixlib=rb-4.1.0&q=85",
  addition: "https://images.unsplash.com/photo-1564703048291-bcf7f001d83d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBob21lJTIwYWRkaXRpb24lMjBjb25zdHJ1Y3Rpb258ZW58MHx8fHwxNzgzMzYyMDc2fDA&ixlib=rb-4.1.0&q=85",
  wholeHome: "https://images.unsplash.com/photo-1628744876497-eb30460be9f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBsaXZpbmclMjByb29tJTIwcmVub3ZhdGlvbiUyMGludGVyaW9yfGVufDB8fHx8MTc4MzM2MjA3NXww&ixlib=rb-4.1.0&q=85",
  living2: "https://images.unsplash.com/photo-1638885930125-85350348d266?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBsaXZpbmclMjByb29tJTIwcmVub3ZhdGlvbiUyMGludGVyaW9yfGVufDB8fHx8MTc4MzM2MjA3NXww&ixlib=rb-4.1.0&q=85",
  bathroom2: "https://images.unsplash.com/photo-1756079664354-34944e001f6d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBtb2Rlcm4lMjBiYXRocm9vbSUyMGludGVyaW9yfGVufDB8fHx8MTc4MzM2MTk5OXww&ixlib=rb-4.1.0&q=85",
  bathroom3: "https://images.pexels.com/photos/7045908/pexels-photo-7045908.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  deck2: "https://images.unsplash.com/photo-1758193431353-87812fbff5cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBob21lJTIwZXh0ZXJpb3IlMjBkZWNrfGVufDB8fHx8MTc4MzM2MTk5OXww&ixlib=rb-4.1.0&q=85",
  patio: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBob21lJTIwYWRkaXRpb24lMjBjb25zdHJ1Y3Rpb258ZW58MHx8fHwxNzgzMzYyMDc2fDA&ixlib=rb-4.1.0&q=85",
};

export const AVATARS = [
  "https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxoYXBweSUyMGhvbWVvd25lciUyMHBvcnRyYWl0JTIwaGVhZHNob3R8ZW58MHx8fHwxNzgzMzYyMDc1fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1639747279286-c07eecb47a0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxoYXBweSUyMGhvbWVvd25lciUyMHBvcnRyYWl0JTIwaGVhZHNob3R8ZW58MHx8fHwxNzgzMzYyMDc1fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1525186402429-b4ff38bedec6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxoYXBweSUyMGhvbWVvd25lciUyMHBvcnRyYWl0JTIwaGVhZHNob3R8ZW58MHx8fHwxNzgzMzYyMDc1fDA&ixlib=rb-4.1.0&q=85",
];

export const SERVICES = [
  {
    slug: "kitchen",
    title: "Kitchen Renovations",
    icon: "ChefHat",
    image: IMAGES.kitchen,
    short: "Chef-worthy kitchens built around how your family really lives.",
    description:
      "From custom cabinetry and stone countertops to smart layouts and statement islands, we craft kitchens that balance beauty with everyday function.",
  },
  {
    slug: "bathroom",
    title: "Bathroom Renovations",
    icon: "Bath",
    image: IMAGES.bathroom,
    short: "Spa-inspired retreats with lasting, water-tight craftsmanship.",
    description:
      "Walk-in showers, soaker tubs, heated floors and elegant tile work — we transform tired bathrooms into calm, functional escapes.",
  },
  {
    slug: "basement",
    title: "Basement Finishing",
    icon: "Layers",
    image: IMAGES.basement,
    short: "Turn unused square footage into your favourite room.",
    description:
      "Home theatres, in-law suites, gyms and play spaces — we finish basements with proper moisture control, insulation and warm, livable design.",
  },
  {
    slug: "additions",
    title: "Home Additions",
    icon: "Building2",
    image: IMAGES.addition,
    short: "More room to grow, seamlessly matched to your home.",
    description:
      "Second-storey builds, sunrooms and bump-outs engineered to blend with your existing structure and add real, lasting value.",
  },
  {
    slug: "whole-home",
    title: "Whole-Home Renovations",
    icon: "Home",
    image: IMAGES.wholeHome,
    short: "A complete transformation, managed end to end.",
    description:
      "One trusted team for design, permits, trades and finishing. We reimagine your entire home with a single point of accountability.",
  },
  {
    slug: "exterior",
    title: "Exterior & Deck Work",
    icon: "TreePine",
    image: IMAGES.exterior,
    short: "Decks, siding and outdoor living built to endure Ontario seasons.",
    description:
      "Custom decks, porches, siding and exterior facelifts crafted with weather-resistant materials and precise, code-compliant construction.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Bright Oak turned our dated kitchen into the heart of our home. The craftsmanship and communication were outstanding from start to finish.",
    name: "Sarah & Mark T.",
    location: "Cambridge, ON",
    avatar: AVATARS[0],
  },
  {
    quote:
      "They finished our basement on time and on budget. The team treated our home with real respect — you can feel the quality in every detail.",
    name: "David L.",
    location: "Kitchener, ON",
    avatar: AVATARS[1],
  },
  {
    quote:
      "Our whole-home reno felt overwhelming until we found Bright Oak. They handled everything and the result exceeded every expectation.",
    name: "Priya M.",
    location: "Waterloo, ON",
    avatar: AVATARS[2],
  },
];

export const GALLERY = [
  { image: IMAGES.kitchen, title: "Modern Kitchen Remodel", category: "Kitchen", area: "Cambridge" },
  { image: IMAGES.wholeHome, title: "Open-Concept Living", category: "Whole-Home", area: "Waterloo" },
  { image: IMAGES.bathroom, title: "Ensuite Spa Retreat", category: "Bathroom", area: "Guelph" },
  { image: IMAGES.basement, title: "Finished Family Basement", category: "Basement", area: "Kitchener" },
  { image: IMAGES.exterior, title: "Cedar Deck & Patio", category: "Exterior", area: "Cambridge" },
  { image: IMAGES.bathroom2, title: "Marble Vanity Bath", category: "Bathroom", area: "Kitchener" },
  { image: IMAGES.living2, title: "Great Room Renovation", category: "Whole-Home", area: "Guelph" },
  { image: IMAGES.deck2, title: "Rooftop Terrace Build", category: "Exterior", area: "Waterloo" },
  { image: IMAGES.bathroom3, title: "Minimal Powder Room", category: "Bathroom", area: "Cambridge" },
];

export const VALUES = [
  { icon: "Hammer", title: "Rooted in Craft", text: "Every joint, tile and finish is executed by seasoned tradespeople who take pride in the details." },
  { icon: "ShieldCheck", title: "Honest & Transparent", text: "Clear quotes, no surprise costs, and steady communication through every phase of your build." },
  { icon: "Clock", title: "On Time, On Budget", text: "Disciplined project management keeps your renovation moving and your investment protected." },
  { icon: "Leaf", title: "Built to Last", text: "Quality materials and proper methods mean work that endures for decades, not seasons." },
];

export const TEAM = [
  { name: "James Bright", role: "Founder & Lead Contractor", avatar: AVATARS[1] },
  { name: "Olivia Oakley", role: "Design & Project Manager", avatar: AVATARS[0] },
  { name: "Daniel Reyes", role: "Master Carpenter", avatar: AVATARS[2] },
];

export const SERVICE_AREAS = [
  { city: "Cambridge", note: "Our home base — Galt, Preston & Hespeler." },
  { city: "Kitchener", note: "Full renovation services across all neighbourhoods." },
  { city: "Waterloo", note: "Kitchens, baths and whole-home projects." },
  { city: "Guelph", note: "Additions, basements and exterior work." },
  { city: "Elmira", note: "Surrounding rural & township properties." },
  { city: "Ayr", note: "Custom decks and home additions." },
  { city: "Paris", note: "Heritage-sensitive renovations." },
  { city: "Woolwich", note: "Serving the greater township area." },
];

export const PROJECT_TYPES = [
  "Kitchen Renovation",
  "Bathroom Renovation",
  "Basement Finishing",
  "Home Addition",
  "Whole-Home Renovation",
  "Exterior / Deck Work",
  "Other",
];

export const BUDGET_RANGES = [
  "Under $25,000",
  "$25,000 – $50,000",
  "$50,000 – $100,000",
  "$100,000 – $250,000",
  "$250,000+",
  "Not sure yet",
];
